import React from 'react';
import PropTypes from 'prop-types';
import './Icon.scss';

const SVGIcon = ({ svg, alt, style }) =>
  svg && (
    <img
      className="material-icons svg-icon"
      aria-hidden="true"
      src={svg}
      style={style}
      alt={alt || ''}
    />
  );

SVGIcon.propTypes = {
  alt: PropTypes.string,
  svg: PropTypes.string,
  style: PropTypes.object,
};

export default SVGIcon;
